import { render, staticRenderFns } from "./CeeYuuFooter2.vue?vue&type=template&id=3a24c04a&scoped=true"
import script from "./CeeYuuFooter2.vue?vue&type=script&lang=js"
export * from "./CeeYuuFooter2.vue?vue&type=script&lang=js"
import style0 from "./CeeYuuFooter2.vue?vue&type=style&index=0&id=3a24c04a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a24c04a",
  null
  
)

export default component.exports